import { AppStorageItemType } from "@multiweb/types/multiweb";

/**
 * Jméno modulu theme. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "theme";

/**
 * Klíč tématu aplikace v local storage.
 */
export const LOCAL_STORAGE_THEME_KEY = AppStorageItemType.userTheme;

/**
 * Typ akce pro změnu tématu.
 * @see createToggleThemeAction
 */
export const TOGGLE_THEME = `${NAME}/TOGGLE_THEME`;

/**
 * Typ akce pro nastavení tématu.
 * @see createSetThemeAction
 */
export const SET_THEME = `${NAME}/SET_THEME`;
